// 예시: notificationApi.js
import { sendRequest } from '@/common/sendRequest';

const notificationApi = {

  // 사용자 모델 목록 조회 API (POST api/authn/mall/notification/selectNotifications)
  async selectNotifications(data) {
    return sendRequest('/api/authn/mall/notification/selectNotifications', {
      method: 'POST',
      data,
    });
  },

  // 알림 단건 삭제 (POST api/authn/mall/notification/deleteNotification)
  async deleteNotification(data) {
    return sendRequest('/api/authn/mall/notification/deleteNotification', {
      method: 'POST',
      data,
    });
  },

  // 알림 다건/전체 삭제 (POST api/authn/mall/notification/deleteNotificationsBatch)
  // - { userSuid } 만 전달 시 해당 사용자의 모든 알림 삭제
  // - { userSuid, alertIds: [...] } 전달 시 지정 알림만 삭제
  async deleteNotificationsBatch(data) {
    return sendRequest('/api/authn/mall/notification/deleteNotificationsBatch', {
      method: 'POST',
      data,
    });
  },


};

export default notificationApi;
